import ShopPaymentModelBase from '../_generated/modelBases/shop-payment-model-base';

export default class ShopPaymentModel extends ShopPaymentModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
